import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { useAppState } from "@/store/useApp";
import { ChevronRight } from "lucide-react";

export const NextSubmissionButton = () => {
  const navigate = useNavigate();
  const currentDocument = useAppState((state) => state.currentDocument);
  const documents = useAppState((state) => state.documents);
  const isPublishingFeedback = useAppState((state) => state.isPublishingFeedback);

  if (!isPublishingFeedback && (currentDocument?.status == "ready" || currentDocument?.status == "in_progress")) {
    return null;
  }

  // Find the next document with status "ready"
  const getNextDocument = () => {
    if (!currentDocument || documents == null) return null;

    const currentIndex = documents.findIndex(
      (doc) => doc.id === currentDocument.id
    );
    if (currentIndex === -1) return null;

    // Look for the next document with status "ready" starting from the current position
    for (let i = currentIndex + 1; i < documents.length; i++) {
      if (documents[i].status === "ready") {
        return documents[i];
      }
    }

    return null;
  };

  const nextDocument = getNextDocument();

  const handleNextSubmission = () => {
    if (nextDocument) {
      navigate(`/documents/${nextDocument.id}`);
    }
  };

  // Don't render if there's no next document
  if (!nextDocument) {
    return null;
  }

  // Enable button as soon as user has requested feedback to be published
  // (i.e., when isPublishingFeedback is true)
  return (
    <Button onClick={handleNextSubmission} className="btn-brand">
      View next submission
      <ChevronRight className="h-4 w-4" />
    </Button>
  );
};
